export default __webpack_public_path__ + "static/media/diceRoll.fed71d77.mp3";